/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

// TODO RS-7140 Update usage of fee to be based on billing class
export const ADVANCED_SCREENING_FEE = 35.0;
export const PREMIUM_SURVEY_FEE = 10.0;

export const BILLING_SUPPORT_EMAIL = 'projects@userinterviews.com';
export const INVOICE_SUPPORT_EMAIL = 'sales@userinterviews.com';

export const COMPENSATION_CANCELLATION_FEE = 0.25;

export const PaymentTypes = {"CARD":0,"INVOICE":1,"PREPAID_BALANCE":2} as const;


export const StatusTypes = {
  NEW: 0,
  PENDING: 1,
  CHARGED: 2,
  REFUNDED: 10,
} as const;

export const READABLE_SKUS = {"b2c_mod":"B2C Mod","b2b_mod":"B2B Mod","b2c_unmod":"B2C Unmod","b2b_unmod":"B2B Unmod","b2c_survey":"B2C Survey","b2b_survey":"B2B Survey"} as const;
